<template>
  <div class="about">
    <Banner type="small" img="about-banner.jpg">
      <h2
        class="banner__title--medium banner__title--separator text--white text--muli text--extrabold mb--x3"
      >
        COMPANY
      </h2>
      <p class="banner__title--text text--white text--normal m--none">
        Neuss Technical Services (NTS) is a company that relies on highly
        experienced professionals, with a global vision to assist the energy
        industry. We offer the highest quality of services and products through
        simple processes, and effective communication, and promote products and
        services in emerging markets. At Neuss, we always seek the solution the
        client truly needs.
      </p>
    </Banner>
    <DcSection class="back--grey--c">
      <div class="container">
        <div class="grid grid__1--1 grid--2--12 grid__gap--35 mb--x7">
          <div class="grid__item">
            <ImageContent source="about/mision.jpg" />
          </div>
          <div class="grid__item grid__item--center-v content--rigth--pd">
            <Title title="mision" color="2d2d2d" position="left" />
            <p class="text--normal text--grey--c">
              Through our expertise, we create and provide specific solutions
              for our clients within the available budgets, and complying with
              the technical and environmental regulations required in the
              context of their businesses.
            </p>
          </div>
        </div>
        <div class="grid grid__1--1 grid--2--12 grid__gap--35">
          <div
            class="grid__item grid__item--center-v content--left--pd order--2--tb"
          >
            <Title
              class="title--left--tb"
              title="vision"
              color="2d2d2d"
              position="right"
            />
            <p class="text--normal text--grey--c text--right text--left--tb">
              To be recognized by our clients as an ally in solving their
              technical operational and global procurement problems , and to
              promote Canadian technologies to South America.
            </p>
          </div>
          <div class="grid__item">
            <ImageContent source="about/vision.jpg" />
          </div>
        </div>
      </div>
    </DcSection>
    <DcSection class="back--white">
      <div class="container">
        <Title title="our core team" color="2d2d2d" position="center" />
        <p
          class="text--normal text--grey--c mb--x3 text--center content--768--center content--595--center-lg"
        >
          NTS is formed by professionals in the gas, oil and power generation
          sectors with <strong>more than 20 years of experience</strong> in
          Maintenance, Production, Engineering, Procurement, Construction and
          Business Development within important transnational companies in
          multiple countries, who have access to a wide contact network around
          the world.
          <!-- We are formed by professionals from the energy sector, in the gas, oil
          and power generation industries, with
          <strong>more than 20 years of experience</strong> in areas such as-->
        </p>
        <div class="grid features grid__col--6 grid__gap--35">
          <Feature image="about/maintenance.png">
            MAINTENANCE
          </Feature>
          <Feature image="about/production.png">
            PRODUCTION
          </Feature>
          <Feature image="about/engineer.png">
            ENGINEERING
          </Feature>
          <Feature image="about/procurement.png">
            PROCUREMENT
          </Feature>
          <Feature image="about/construccion.png">
            CONSTRUCTION
          </Feature>
          <Feature image="about/business.png">
            BUSINESS <br />DEVELOPMENT
          </Feature>
        </div>
      </div>
    </DcSection>
    <DcSection class="back--grey--c">
      <div class="container">
        <Title title="core values" color="2d2d2d" position="center" />
        <div class="grid__values">
          <div class="grid__values--item">
            <figure class="grid__values--image">
              <img src="@/assets/about/customer-service.jpg" />
            </figure>
            <div class="grid__values--content">
              <Title
                title="Build relationships"
                color="ffffff"
                position="left"
                textTransform="Capitalize"
              />
              <p class="text--small text--grey--d">
                We focus relentlessly not only on the customer, to provide
                flexible, practical and value added solutions but also in our
                partners and providers to drive success.
              </p>
            </div>
          </div>
          <div class="grid__values--item">
            <figure class="grid__values--image">
              <img src="@/assets/about/innovation.jpg" />
            </figure>
            <div class="grid__values--content">
              <Title
                title="Innovate"
                color="ffffff"
                position="left"
                textTransform="Capitalize"
              />
              <p class="text--small text--grey--d">
                We approach our business with creativity, fresh ideas, lateral
                thinking and a commitment to do things in a new way.
              </p>
            </div>
          </div>
          <div class="grid__values--item">
            <figure class="grid__values--image">
              <img src="@/assets/about/integrity.jpg" />
            </figure>
            <div class="grid__values--content">
              <Title
                title="Operate with Transparency"
                color="ffffff"
                position="left"
                textTransform="Capitalize"
                twoLines
              />
              <p class="text--small text--grey--d">
                We are dependable and responsible people committed to being
                honest and direct in all of our activities.
              </p>
            </div>
          </div>
          <div class="grid__values--item">
            <figure class="grid__values--image">
              <img src="@/assets/about/excellence.jpg" />
            </figure>
            <div class="grid__values--content">
              <Title
                title="Practice excellence first"
                color="ffffff"
                position="left"
                textTransform="Capitalize"
                twoLines
              />
              <p class="text--small text--grey--d">
                We are dedicated to continuous improvement which is reflected in
                our leadership in best practice implementation.
              </p>
            </div>
          </div>
          <div class="grid__values--item">
            <figure class="grid__values--image">
              <img src="@/assets/about/people.jpg" />
            </figure>
            <div class="grid__values--content">
              <Title
                title="Build teamwork spirit"
                color="ffffff"
                position="left"
                textTransform="Capitalize"
              />
              <p class="text--small text--grey--d">
                We succeed through teamwork based on mutual respect and the
                desire to invest in each other’s success.
              </p>
            </div>
          </div>
        </div>
      </div>
    </DcSection>
    <DcSection class="back--white">
      <div class="container">
        <div class="grid grid__1--1 grid--2--12 grid__gap--35 mb--x7">
          <div class="grid__item">
            <ImageContent source="about/healt.jpg" />
          </div>
          <div class="grid__item grid__item--center-v content--rigth--pd">
            <Title
              title="Occupational Health and Safety (OHS) Management System"
              color="2d2d2d"
              position="left"
              twoLines
            />
            <p class="text--normal text--grey--c">
              Our employees are practitioners of OHS programs , we strive to
              work in safe, healthy and environmentally friendly places, for
              which we focus on mitigating and eliminating potential risks for
              all our employees, contractors, subcontractors and third parties.
              Our OHS Management System meets the requirements ISO 45001: 2018.
            </p>
          </div>
        </div>
        <div class="grid grid__1--1 grid--2--12 grid__gap--35 mb--x7">
          <div
            class="grid__item grid__item--center-v content--left--pd order--2--tb"
          >
            <Title
              class="title--left--tb"
              title="Quality Policy"
              color="2d2d2d"
              position="right"
            />
            <p class="text--normal text--grey--c text--right text--left--tb">
              Neuss Technical Services is committed to provide high quality
              services and shall implement a quality management system based in
              the requirements of ISO 9001:2015 incorporating the most relevant
              elements.
            </p>
          </div>
          <div class="grid__item">
            <ImageContent source="about/iso.jpg" />
          </div>
        </div>
        <div class="grid grid__1--1 grid--2--12 grid__gap--35 ">
          <div class="grid__item">
            <ImageContent source="about/equality.jpg" />
          </div>
          <div class="grid__item grid__item--center-v content--rigth--pd">
            <Title
              title="NEUSS TECHNICAL SERVICES"
              color="2d2d2d"
              position="left"
              twoLines
            />
            <p class="text--normal text--grey--c mt--x3 mb--x2">
              work environment abides by the rules, policies and regulations
              regarding:
            </p>
            <ul class="">
              <li class="list">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Sexual Harassment
                </p>
              </li>
              <li class="list">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Discrimination
                </p>
              </li>
              <li class="list">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Anti corruption Policy
                </p>
              </li>
              <li class="list">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Environmental Protection
                </p>
              </li>
              <li class="list">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Occupational Health and Safety Regulations
                </p>
              </li>
              <li class="list">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Equality of women and men
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </DcSection>
    <!--<CallAction backgroundImage="call__contact.png" backgroundColor="#efdc30">
      <h2 class="title__section text--white mb--x3">
        HAVE A QUESTIONS OR HAVE A SPECIAL REQUEST?
      </h2>
      <p class="text--normal text--white text__content--normal  mb--x3">
        We are ready to help you. In fact, we promise to get back to you in less
        than 12 hours.
      </p>
      <NeButton routeLink="/contact" align="left">
        contact us for a quote
      </NeButton>
    </CallAction>-->
  </div>
</template>

<script>
import Banner from "@/components/Banner.vue";
import Title from "@/components/NeTitle.vue";
import ImageContent from "@/components/ImageContent.vue";
import Feature from "@/components/Feature.vue";
//import CallAction from "@/components/CallAction.vue";
//import NeButton from "@/components/Button.vue";

import DcSection from "@/layouts/DcSection.vue";

export default {
  metaInfo: {
    title: "Company",
    meta: [
      {
        name: "description",
        hid: "description",
        content:
          "We offer the highest quality of services and products through simple processes, and effective communication, and promote them in emerging markets"
      },
      // Open Graph
      { name: "og:title", content: "Company | Neuss Technical Services" },
      {
        name: "og:description",
        content:
          "We offer the highest quality of services and products through simple processes, and effective communication, and promote them in emerging markets"
      },
      { name: "og:type", content: "website" },
      { name: "og:url", content: "https://www.neuss-ts.com/" },
      { name: "og:image", content: "https://davecastworks.com/meta_640.jpg" },
      // Twitter Card
      { name: "twitter:card", content: "summary" },
      { name: "twitter:site", content: "@neussts" },
      { name: "twitter:title", content: "Company | Neuss Technical Services" },
      {
        name: "twitter:description",
        content:
          "We offer the highest quality of services and products through simple processes, and effective communication, and promote them in emerging markets"
      },
      {
        name: "twitter:image",
        content: "https://davecastworks.com/meta_640.jpg"
      },
      { name: "twitter:image:alt", content: "NeussTS Logo" }
    ]
  },
  name: "Company",
  components: {
    Banner,
    DcSection,
    Title,
    ImageContent,
    Feature
  },
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>

<style scoped>
.grid__values {
  padding-top: 10px;
  display: grid;
  grid-gap: 35px;
  grid-template-columns: repeat(6, 1fr);
  grid-template-areas:
    "item1 item1 item2 item2 item3 item3"
    ". item4 item4 item5 item5 .";
}
.grid__values--item {
  position: relative;
}
.grid__values--item:nth-child(1) {
  grid-area: item1;
}
.grid__values--item:nth-child(2) {
  grid-area: item2;
}
.grid__values--item:nth-child(3) {
  grid-area: item3;
}
.grid__values--item:nth-child(4) {
  grid-area: item4;
}
.grid__values--item:nth-child(5) {
  grid-area: item5;
}
.grid__values--image {
  max-width: 100%;
}
.grid__values--image img {
  max-width: 100%;
}
.grid__values--content {
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 30px;
  box-sizing: border-box;
}
@media screen and (max-width: 980px) {
  .features.grid__col--6 {
    grid-template: 1fr / repeat(3, 1fr);
  }
  .grid__values {
    padding-top: 25px;
    grid-template-columns: repeat(4, 1fr);
    grid-template-areas:
      "item1 item1 item2 item2"
      "item3 item3 item4 item4"
      ". item5 item5 .";
  }
}
@media screen and (max-width: 768px) {
  .features.grid__col--6 {
    grid-template: 1fr / repeat(12, 1fr);
    grid-gap: 20px 10px;
    grid-template-areas:
      ". feature1 feature1 feature1 feature1 . . feature2 feature2 feature2 feature2 ."
      ". feature3 feature3 feature3 feature3 . . feature4 feature4 feature4 feature4 ."
      ". feature5 feature5 feature5 feature5 . . feature6 feature6 feature6 feature6 .";
  }
  .features .feature:nth-child(1) {
    grid-area: feature1;
  }
  .features .feature:nth-child(2) {
    grid-area: feature2;
  }
  .features .feature:nth-child(3) {
    grid-area: feature3;
  }
  .features .feature:nth-child(4) {
    grid-area: feature4;
  }
  .features .feature:nth-child(5) {
    grid-area: feature5;
  }
  .features .feature:nth-child(6) {
    grid-area: feature6;
  }
  .grid__values {
    padding-top: 25px;
    grid-template-columns: repeat(4, 1fr);
    grid-template-areas:
      "item1 item1 item1 item1"
      "item2 item2 item2 item2"
      "item3 item3 item3 item3"
      "item4 item4 item4 item4"
      "item5 item5 item5 item5";
  }
  .grid__values--image {
    overflow: hidden;
    max-height: 300px;
  }
  .grid__values--image img {
    width: 100%;
    height: 300px;
    object-fit: cover;
    object-position: top;
  }
  .text--small {
    font-size: 16px;
    line-height: 28px;
  }
  .grid__1--1 {
    grid-template: 1fr / 1fr;
  }
}

@media screen and (max-width: 595px) {
  .features.grid__col--6 {
    grid-template: 1fr / repeat(12, 1fr);
    grid-gap: 20px 10px;
    grid-template-areas:
      ". feature1 feature1 feature1 feature1 feature1 feature1 feature1 feature1 feature1 feature1 ."
      ". feature2 feature2 feature2 feature2 feature2 feature2 feature2 feature2 feature2 feature2 ."
      ". feature3 feature3 feature3 feature3 feature3 feature3 feature3 feature3 feature3 feature3 ."
      ". feature4 feature4 feature4 feature4 feature4 feature4 feature4 feature4 feature4 feature4 ."
      ". feature5 feature5 feature5 feature5 feature5 feature5 feature5 feature5 feature5 feature5 ."
      ". feature6 feature6 feature6 feature6 feature6 feature6 feature6 feature6 feature6 feature6 .";
  }
  .grid__values--content {
    padding: 10px 20px;
  }
  .text--small {
    font-size: 14px;
    line-height: 24px;
  }
}
</style>
